import React, { useEffect, useState } from "react";
import general from "../../general";
import $ from "jquery";
import {
  useLocalStorageState,
  useLockFn,
  useReactive,
  useScroll,
} from "ahooks";
import KeepScroll from "../../lib/KeepScroll";
import dayjs from "dayjs";
import { NavLink } from "../../lib/Navigation";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";
import { CSSTransition } from "react-transition-group";
import { activityUrl } from "../../config";

const types = [
  {
    id: "can",
    text: "待赎回",
  },
  {
    id: "ed",
    text: "已赎回",
  },
  {
    id: "expire",
    text: "已过期",
  },
];

export default (props) => {
  const [typeIndex, setTypeIndex] = useState(0);
  //  useLocalStorageState("recovery-type", {
  //   defaultValue: 0,
  // });
  const datas = useReactive(
    types.map((item) => ({
      id: item.id,
      text: item.text,
      init: false,
      loading: null,
      page: 1,
      more: null,
      datas: [],
    }))
  );
  const load = useLockFn(async (parms = {}) => {
    let data = datas[typeIndex];
    if (data.loading) {
      return;
    }
    data.loading = true;
    Dialog.loading();
    let tmp = {
      pagination: { count: 20, page: data.page },
    };
    if (data.id === "can") {
      tmp.isRedeem = true;
    }
    if (data.id === "ed") {
      tmp.isRedeemed = true;
    }
    if (data.id === "expire") {
      tmp.isRedeem = false;
    }
    if (parms.page) {
      tmp.pagination.page = parms.page;
    }
    await general.axios
      .post("/v3/recycledAlts", tmp)
      .finally(() => {
        data.loading = false;
        Dialog.close();
      })
      .then((res) => {
        data.init = true;
        let {
          status,
          data: { list, paginated },
        } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          if (parms.page) {
            data.page = parms.page;
          }
        }
        data.datas =
          parms.page === 1 || !parms.page ? list : [...data.datas, ...list];
        data.more = paginated.more && list.length > 0;
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  });
  useEffect(() => {
    if (props.active && !datas[typeIndex].init) {
      load();
    }
  }, [props.active, typeIndex]);
  useEffect(() => {
    if (props.active) {
      load({ page: 1 });
    }
  }, [props.active]);

  const scroll = useScroll();
  useEffect(() => {
    let data = datas[typeIndex];
    if (props.active && data.init) {
      if (scroll?.top < -80) {
        load({ page: 1 });
      }
      if (
        scroll?.top + window.innerHeight + 20 >= $(document).height() &&
        data.init &&
        data.more
      ) {
        load({ page: data.page + 1 });
      }
    }
  }, [scroll, props.active]);

  const [data, setData] = useState();
  const [confirm, setConfirm] = useState();
  const [confirmed, setConfirmed] = useState();

  useEffect(() => {
    if (confirm) {
      // iOS Safari 兼容处理：同时设置 html 和 body
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.height = "100%";
    } else {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
    }
    // 清理函数：组件卸载时恢复样式
    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.height = "";
    };
  }, [confirm, props.active]);

  return (
    <div className="recovery-record">
      <div className="record-head">
        {types.map((item, index) => (
          <div
            key={index}
            className={"item" + (index === typeIndex ? " active" : "")}
            onClick={() => setTypeIndex(index)}
          >
            {item.text}
          </div>
        ))}
      </div>
      <div className="record-body">
        {datas.map((type, index) => (
          <div
            key={index}
            className={"type-item" + (index === typeIndex ? " active" : "")}
          >
            <KeepScroll active={index === typeIndex}>
              {type.datas.map((item, index) => (
                <div
                  key={index}
                  className={"record-item " + type.id}
                  style={{
                    borderBottom:
                      type.datas.length === index + 1
                        ? "none"
                        : "1px solid #eee",
                    marginBottom:
                      type.datas.length === index + 1 ? "0" : "16px",
                  }}
                  onClick={() => {
                    if (type.id === "can") {
                      setData(item);
                      setConfirm(true);
                    }
                  }}
                >
                  <div className="recovery-item-game">
                    <div className="icon">
                      <Image src={item.game.img.thumb} alt="" />
                    </div>

                    <div>
                      <div className="name">
                        {item.game.name_main || item.game.name}
                        {item.game.name_branch ? (
                          <div className="game-name-branch">
                            {item.game.name_branch}
                          </div>
                        ) : null}
                      </div>

                      <div className="desc">小号昵称：{item.alt.alias}</div>

                      <div
                        className="desc"
                        style={{ marginTop: "5px", fontSize: "0.24rem" }}
                      >
                        回收成功金额：<span>{item.recycledCoin}平台币</span>
                      </div>
                    </div>
                  </div>

                  <div className="subject">
                    <div
                      className="operate"
                      style={{ display: type.id === "can" ? "block" : "flex" }}
                    >
                      <div
                        className="price"
                        style={{
                          marginBottom: type.id === "can" ? "5px" : "0",
                        }}
                      >
                        赎回应付：<span>¥{item.redeemdAmount}</span>
                      </div>
                      <div className="time">
                        {type.id === "ed" ? (
                          <>
                            赎回时间：
                            {dayjs
                              .unix(item.redeemedTime)
                              .format("YYYY-MM-DD HH:mm:ss")}
                          </>
                        ) : (
                          <>
                            过期时间：
                            {dayjs
                              .unix(item.redeemEndTime)
                              .format("YYYY-MM-DD HH:mm:ss")}
                          </>
                        )}
                      </div>
                    </div>

                    {type.id === "can" && (
                      <div className="go-redeem">去赎回</div>
                    )}
                  </div>
                </div>
              ))}

              {type.datas.length > 0 && type.init ? (
                <div className="recovery-empty" style={{ marginTop: "45px" }}>
                  ~~无更多数据~~
                </div>
              ) : null}

              {type.datas.length === 0 && type.init ? (
                <div className="recovery-empty">
                  <img src="/resources/recovery/empty.png" alt="" />
                  暂无数据
                </div>
              ) : null}
            </KeepScroll>
          </div>
        ))}
      </div>

      <CSSTransition
        in={confirm}
        timeout={250}
        appear={true}
        unmountOnExit={true}
      >
        <div className="trade-confirm">
          <div className="container" style={{ height: "auto" }}>
            <div className="head" style={{ paddingBottom: "17px" }}>
              <div className="title">赎回须知</div>

              <img
                style={{ width: "20px", height: "20px" }}
                src="/resources/four-three/trade/close.png"
                alt=""
                onClick={() => {
                  setConfirm(false);
                }}
              />
            </div>

            <div className="main">
              <div className="body">
                <div className="content">
                  <p>回收后24小时内可赎回，逾期不可赎回。</p>
                  <p>
                    赎回小号仅支持现金赎回，需额外支付该小号充值金额的3%
                    作为赎回手续费。（例：若小号充值满100元，回收后可获得
                    50平台币。若用户需要赎回，则需支付5+3=8元）。
                  </p>
                  <p>如有任何疑问，可联系客服咨询！</p>
                </div>
              </div>
            </div>

            <div className="operate">
              <div className="input" onClick={() => setConfirmed(true)}>
                <img
                  src={
                    confirmed
                      ? "/resources/four-three/trade/radio-selected.png"
                      : "/resources/four-three/trade/radio.png"
                  }
                  alt=""
                />
                我已阅读
              </div>

              <div className="btns">
                <div className="btn" onClick={() => setConfirm(false)}>
                  我再想想
                </div>

                <NavLink
                  to={`${activityUrl}/alt-redemption?id=${data?.id}`}
                  // to={data?.redeemUrl}
                  iframe={{ title: "赎回" }}
                  className={"btn redemption" + (confirmed ? " confirm" : "")}
                  onClick={(e) => {
                    if (confirmed) {
                      setConfirm(false);
                    } else {
                      e.preventDefault();
                      e.stopPropagation();
                      Dialog.info("请先阅读并勾选赎回须知");
                    }
                  }}
                >
                  <span className="price">
                    ¥<span>{data?.redeemdAmount}</span>
                  </span>
                  确认赎回
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};
